import toJSON from './toJSON';

let settings = {
	showing: false,
	width: 400,
	height: 400,
	left: 16,
	top: 16,
	eventObjectsOpenedByDefault: false,
	cmsWebAsSource: false,
	cmsWebHighlightDiff: true,
	fullscreen: false,
	order: 'Newest on top',
	promptUnload: false,
	additionalSources: [],
	filters: [],
	...JSON.parse(
		(typeof window !== 'undefined' &&
			localStorage.getItem('ws-tagging-ev-settings')) ||
			'{}'
	)
};
const watchers = new Set();
export const getSettings = () => ({ ...settings });
export const watchSettings = (callback) => {
	watchers.add(callback);
	callback(settings);
};
export const unwatchSettings = (callback) => {
	watchers.delete(callback);
};
export const setSetting = (name, value) => {
	const newSettings = {
		...settings,
		[name]: value
	};
	if (toJSON(settings) !== toJSON(newSettings)) {
		settings = newSettings;
		localStorage.setItem(
			'ws-tagging-ev-settings',
			JSON.stringify(newSettings)
		);
		watchers.forEach((callback) => callback(newSettings));
	}
};
/*
  The localStorage settings are modfied outside of this module in be beforeEach test, this is used to reload them.
  But can also be used outside of testing if some script ever directly modifies the localStorage settings
*/
export const refreshSettings = () => {
	settings = {
		showing: false,
		width: 400,
		height: 400,
		left: 16,
		top: 16,
		eventObjectsOpenedByDefault: false,
		cmsWebAsSource: false,
		cmsWebHighlightDiff: true,
		fullscreen: false,
		order: 'Newest on top',
		promptUnload: false,
		additionalSources: [],
		filters: [],
		...JSON.parse(localStorage.getItem('ws-tagging-ev-settings') || '{}')
	};
};
export const unwatchAll = () => {
	watchers.clear();
};
